import { Card, Layout, SectionMessage } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { AppHeader } from "./app-header/AppHeader";
import { AppNavigation } from "./app-navigation/AppNavigation";

export function PageNotFoundError() {
  const { t } = useTranslation();
  return (
    <Layout
      layout="narrow"
      header={<AppHeader />}
      navigation={<AppNavigation />}
    >
      <Card border="border-base">
        <SectionMessage
          sectionTitle={t("Page not found!")}
          type="info"
          icon="warning"
        />
      </Card>
    </Layout>
  );
}
